/* global tippy */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import logo from "./logo.svg";
import "./App.css";
import Papa from "papaparse";
import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import ListGames from "./listGames";
import CoachSchedule from "./CoachSchedule";
import NotesSchedule from "./NotesSchedule";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid"; // a plugin!

// Only events on/after this date are shown in the "All Teams" view.
// Individual team views always show the full season.
const ALL_TEAMS_CUTOFF = new Date(2026, 7, 1); // August 1, 2026 (months are 0-indexed)

const makeUnique = (array = [], keys = []) => {
  if (!keys.length || !array.length) return [];

  return array.reduce((list, item) => {
    const hasItem = list.find((listItem) => keys.every((key) => listItem[key] === item[key]));
    if (!hasItem) list.push(item);
    return list;
  }, []);
};
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<All />} />
        <Route path="/list" element={<All />} />
        <Route path="/coach_schedule/:dayString?/:endOfPeriod?" element={<CoachSchedule />} />
        <Route path="/notes/:dayString?/:endOfPeriod?" element={<NotesSchedule />} />
        <Route path="/team_schedule/:team?" element={<All />} />
      </Routes>
    </BrowserRouter>
  );
}

function All() {
  const [show, setShow] = useState(false);
  const [activeEvent, setActiveEvent] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [currentView, setCurrentView] = useState("list");
  const [teamID, setTeamID] = useState(useParams().team);
  const [data, setData] = useState([]);
  let handleSportChange = (event) => {
    console.log(event.target.value);
    if (event.target.value === "All Teams") {
      setTeamID(null);
    } else {
      setTeamID(event.target.value);
    }

    // window.location.href = `/team_schedule/${event.target.value}`;
    // window.location.reload();
  };
  let handleMouseEnter = (arg) => {
    let props = arg.event;
    tippy(arg.el, {
      content: `<div className="details"> ${props.extendedProps.actualTitle.length > 0 ? props.extendedProps.actualTitle + "<br/>" : ""} ${
        props.extendedProps.team
      } ${props.extendedProps.away ? " (A)" : " (H)"}<br><b>Opponent</b>: ${props.extendedProps.opponent}<br> <b>Time: </b>${
        props.extendedProps.time
      }<br><b>Location</b>: ${props.extendedProps.location}</details>`,
      placement: "top",
      appendTo: () => document.body,
      allowHTML: true,
      interactive: true,
    });
  };
  useEffect(() => {
    Papa.parse(`https://docs.google.com/spreadsheets/d/1agD_PdBRs4L7EGjUXJkwx6baHmZIuedcl7cXeklxBwU/export?format=csv&v=${Date.now()}`, {
      download: true,
      header: true,

      complete: (results) => {
        let processed = [];
        results.data.map((event) => {
          // Split the date
          let allDay = false;
          const [month, day, year] = event["Game Date"].substring(0, 10).split("/");

          // Parse time and convert to 24-hour format
          const [time, meridiem] = event["Game Time"].split(" ");
          let [hour, minute] = time.split(":").map(Number);
          try {
            if (meridiem.toUpperCase() === "PM" && hour !== 12) {
              hour += 12;
            } else if (meridiem.toUpperCase() === "AM" && hour === 12) {
              hour = 0;
            }
          } catch (error) {
            console.log(error);
            hour = "";
            minute = "";
            allDay = true;
          }

          // Create the date object in local time
          const date = new Date(year, month - 1, day, hour, minute);

          // Convert to ISO 8601 format (UTC)
          const startISOString = date.toISOString();

          if (event["Title"].toLowerCase().indexOf("practice") < 0) {
            processed.push({
              teamID: event["Group ID"],
              date: event["Game Date"],
              score: event["Score1"],
              win: event["Winloss1"],
              actualTitle: event["Title"],
              isCancelled: event["Cancelled Ind"] == "1",
              isRescheduled: event["Rescheduled Ind"] == "1",
              title: `${event["Cancelled Ind"] == "1" ? "Cancelled -" : ""}${event["Rescheduled Ind"] == "1" ? "Rescheduled -" : ""}${
                event["Home/Away"].indexOf("Away") > -1 ? "(A) " : "(H) "
              } ${event["Sport Level Title"] + " - " + event["Name"]}`,
              team: event["Sport Level Title"],
              away: event["Home/Away"].indexOf("Away") > -1,
              dismissal: event["Student Dismissal Time"],
              departure: event["Departure Time"],
              transportation: event["Transportation"],
              address: event["Room Name"]
                ? "3901 Fieldston Road, Bronx, NY, 10417"
                : event["Line One"].length > 0
                ? event["Line One"] + ", " + event["City"] + ", " + event["State"] + " " + event["Zip"]
                : "",
              start: startISOString,
              end: allDay ? startISOString : new Date(date.getTime() + 2 * 60 * 60 * 1000).toISOString(), // Assuming a 2-hour game duration
              description: event["Description"],
              notes: event["Long Description"],
              opponent: event["Name"],
              time: event["Game Time"],
              location: event["Room Name"].length > 0 ? event["Room Name"] : event["Location"],
              allDay: allDay,
              backgroundColor: event["Cancelled Ind"] == "1" ? "red" : event["Rescheduled Ind"] == "1" ? "grey" : "",
            });
          }
        });
        console.log(results.data);
        setData(processed);
      },
    });
    // Tabletop.init({
    //   key: "187cjvjLlbjlE8VqvBXvybdB2idg27cQn0tAx0RZSXFs",
    //   simpleSheet: true,
    // })
    //   .then((responseData) => {
    //     // console.log(responseData);
    //   })
    //   .catch((err) => console.warn(err));
  }, []);
  console.log(teamID);
  return (
    <div className="App">
      <div style={{ padding: "5px" }}>
        {/* <fieldset className="legend">
          <FontAwesomeIcon icon="fa-solid fa-house" />
          <span>
            <i class="fa-solid fa-house"></i> Home
          </span>
          <span>
            <i class="fa-solid fa-bus"></i> Bus
          </span>
          <span>
            <i class="fa-solid fa-history"></i> Postponed
          </span>
          <span>
            <i class="fa-solid fa-exclamation-triangle"></i> Postponed
          </span>
          <span>
            <i class="fa-solid fa-check"></i> Past
          </span>
        </fieldset> */}
        {!useParams().team ? (
          <fieldset className="legend">
            <select onChange={handleSportChange.bind(this)}>
              <option key="all-teams" selected={!teamID}>
                All Teams
              </option>
              {Array.from(makeUnique(data, ["teamID"]))
                .toSorted((a, b) => (a.team > b.team ? 1 : -1))
                .map((sport) => (
                  <option
                    key={sport.team.toLowerCase().replaceAll(" ", "-")}
                    value={sport.team.toLowerCase().replaceAll(" ", "-")}
                    selected={sport.team.toLowerCase().replaceAll(" ", "-") == teamID}
                  >
                    {sport.team}
                  </option>
                ))}
            </select>
          </fieldset>
        ) : (
          ""
        )}
        <div style={{ display: "flex", justifyContent: "right", gap: "4px" }}>
          <button className="toggles" onClick={() => setCurrentView("list")} disabled={currentView === "list"}>
            <i class="fa-solid fa-list"></i>
          </button>
          <button className="toggles" onClick={() => setCurrentView("calendar")} disabled={currentView === "calendar"}>
            <i class="fa-solid fa-calendar"></i>
          </button>
        </div>
        {console.log(data)}
        {currentView == "list" ? (
          <div style={{ width: "100vw", overflowX: "auto" }}>
            <ListGames
              teamID={teamID}
              selectFromList={(event) => {
                console.log(event);
                setActiveEvent(event);
                handleShow();
              }}
              games={data.filter((event) => {
                if (!teamID) return new Date(event.start) >= ALL_TEAMS_CUTOFF; // "All Teams" view only shows events from the cutoff on
                return event.team.toLowerCase().replaceAll(" ", "-") === teamID.toLowerCase(); // Filter by team ID
              })}
            />
          </div>
        ) : (
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin]}
            initialView="dayGridMonth"
            weekends={true}
            events={data.filter((event) => {
              console.log(event.team.toLowerCase().replaceAll(" ", "-"));
              if (!teamID) return new Date(event.start) >= ALL_TEAMS_CUTOFF; // "All Teams" view only shows events from the cutoff on
              return event.team.toLowerCase().replaceAll(" ", "-") === teamID.toLowerCase(); // Filter by team ID
            })}
            height={"auto"}
            displayEventEnd={false}
            eventMouseEnter={handleMouseEnter}
            eventClick={(info) => {
              console.log(info.event);
              setActiveEvent({
                actualTitle: info.event.extendedProps.actualTitle,
                title: info.event.title,
                score: info.event.extendedProps.score,
                team: info.event.extendedProps.team,
                away: info.event.extendedProps.away,
                opponent: info.event.extendedProps.opponent,
                dismissal: info.event.extendedProps.dismissal,
                departure: info.event.extendedProps.departure,
                transportation: info.event.extendedProps.transportation,
                start: info.event.start,
                end: info.event.end,
                address: info.event.address,
                description: info.event.extendedProps.description,
                notes: info.event.extendedProps.notes,
                location: info.event.extendedProps.location,
                time: info.event.extendedProps.time,
                allDay: info.event.allDay,
              });
              handleShow();
            }}
            displayEventTime={false}
            eventDisplay={"block"}
            headerToolbar={{
              left: "prev,today,next",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay", // user can switch between the two
            }}
          />
        )}
      </div>
      <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{activeEvent.actualTitle?.length > 0 ? activeEvent.actualTitle : activeEvent.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack gap={3}>
            <p>
              <b>
                {activeEvent.away ? "(A)" : "(H)"} {activeEvent.team} vs. {activeEvent.opponent} {activeEvent.away ? "(H)" : "(A)"}
              </b>
            </p>
            <p>
              <b>Time:</b> {activeEvent.time} <br />
              <b>Location:</b> {activeEvent.location}
              <br />
              <b>Transportation:</b> {activeEvent.transportation} <br />
              <b>Address: </b> {activeEvent.address} <br />
              <b>Dismissal:</b> {activeEvent.dismissal} <br />
              <b>Departure:</b> {activeEvent.departure} <br />
            </p>
            <p></p>
            <p>
              <b>Notes:</b> {activeEvent.notes}
            </p>
            {/* <iframe
              style={{ maxWidth: "400px", width: "100%", border: 0, aspectRatio: "1/1" }}
              loading="lazy"
              allowfullscreen
              referrerpolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBJGa7fLlztAVBCRljiE5S_WlOt1UrmWqI
    &q=${activeEvent.address}`}
            ></iframe> */}
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default App;
